import callAPiBase from './base';

const terminalApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/terminalList',
      method: 'GET',
      useToken: true,
      title: 'Terminal - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/terminalCreate',
      method: 'POST',
      useToken: true,
      title: 'Terminal - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/terminalUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Terminal - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/terminalDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Terminal - Delete',
      params,
    }),
  gateUpdate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/gateUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Gate - Update',
      data,
    }),
  listConfig: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/terminalIpsList',
      method: 'GET',
      useToken: true,
      title: 'Terminal - Get IP List',
      params,
    }),
  updateConfig: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/terminalIpsUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Terminal - Update IPs',
      data,
    }),
};

export { terminalApi };
export default terminalApi;
